export default __webpack_public_path__ + "static/media/ban-mobile-image-10.bedafa2f.jpg";